module.exports = __webpack_public_path__ + "img/imagine.996427ae.png";